//header

const refs = {
  burgerButton: document.querySelector('.header__burger-button'),
  closeButton: document.querySelector('.header__close-button'),
  mobileMenu: document.querySelector('.mobile-menu'),
  mobileWrapper: document.querySelector('.wrapper'),
};

document.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  initHeaderScroll();
});

function initMobileMenu() {
  refs.burgerButton.addEventListener('click', showMobileMenu);
  refs.closeButton.addEventListener('click', hideMobileMenu);

  refs.mobileWrapper.addEventListener('click', e => {
    if (e.target === e.currentTarget) hideMobileMenu();
  });
}

function initHeaderScroll() {
  const header = document.querySelector('.header');
  let lastScroll = 0;
  const scrollThreshold = 10;

  window.addEventListener('scroll', () => {
    const currentScroll =
      window.pageYOffset || document.documentElement.scrollTop;

    // Якщо скрол в самій горі — показуємо хедер
    if (currentScroll <= 0) {
      header.classList.remove('hide');
      return;
    }

    if (Math.abs(currentScroll - lastScroll) < scrollThreshold) return;

    if (currentScroll > lastScroll && currentScroll > header.offsetHeight) {
      // Скрол вниз
      header.classList.add('hide');
    } else {
      // Скрол вгору
      header.classList.remove('hide');
    }

    lastScroll = currentScroll;
  });
}

function showMobileMenu() {
  refs.closeButton.classList.remove('hidden');
  refs.burgerButton.classList.add('hidden');
  refs.mobileMenu.classList.add('visible');
  refs.mobileWrapper.classList.add('visible');
  lenis.stop();
  document.body.classList.add('no-scroll');
}

function hideMobileMenu() {
  refs.closeButton.classList.add('hidden');
  refs.burgerButton.classList.remove('hidden');
  refs.mobileMenu.classList.remove('visible');
  refs.mobileWrapper.classList.remove('visible');
  lenis.start();
  document.body.classList.remove('no-scroll');
}
